import { makeStyles } from '@mui/styles';
import { CHAT_LIST_WIDTH } from './constants';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  chats: {
    background: theme.palette.background.paper,
    boxSizing: 'border-box',
    borderRadius: '15px',
    padding: '20px',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateRows: '40px 1fr',
    maxWidth: '1000px',
    width: '100%',
    margin: '20px auto',
  },
  chatsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  chatList: {
    margin: '10px 0',
    display: 'flex',
    gap: '20px',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
  },
  chatItem: {
    padding: '20px',
    borderRadius: '10px',
    border: '1px solid #00000075',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': { boxShadow: '0 1px 1px 1px rgba(0, 0, 0, 0.2)' },
  },
  lockIcon: { marginRight: '10px' },
  lockIconHidden: {
    marginRight: '10px',
    opacity: 0,
  },
  chatName: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
    '& div': {
      textOverflow: 'ellipsis',
      width: '100%',
      overflow: 'hidden',
      wordWrap: 'break-word',
    },
  },
  chatItemActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '12rem',
  },
  ticketLink: {
    '&:hover': { textDecoration: 'underline' },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  chatsList: {
    height: '100%',
    maxWidth: CHAT_LIST_WIDTH,
    minWidth: '350px',
    overflowY: 'auto',
    padding: '10px',
    boxSizing: 'border-box',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  chatsListItem: {
    margin: '0px 10px',
    background: theme.palette.background.paper,
    borderRadius: '5px',
    border: '1px solid var(--color-primary)',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    cursor: 'pointer',
    borderColor: theme.palette.mode === Mode.Dark ? '#FFFFFF1F' : 'var(--color-primary)',
  },
  chatListItemTopRow: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    background:
      theme.palette.mode === Mode.Dark
        ? theme.palette.background.default
        : 'var(--color-primary-light)',
    padding: '15px',
    color: theme.palette.secondary.contrastText,
    borderRadius: '5px 5px 0 0',
  },
  chatListItemTicketDetails: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
  },
  chatSummary: {
    fontWeight: '600',
    overflow: 'hidden',
    width: '100%',
  },
  chatLastMessage: {
    opacity: '0.5',
  },
  chatStatus: {
    fontSize: 'small !important',
    border: '1px solid rgba(0,0,0, 0.15)',
    width: 'fit-content',
    fontWeight: '700',
    color:
      theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText,
    background:
      theme.palette.mode === Mode.Dark
        ? theme.palette.background.paper
        : theme.palette.primary.main,
    borderRadius: '10px',
    padding: '5px 10px',
    boxSizing: 'border-box',
  },
  chatData: {
    display: 'flex',
    gap: '5px',
    padding: '20px',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  activeChat: {
    transition: '0.25s background',
    background:
      theme.palette.mode === Mode.Dark ? theme.palette.common.black : 'var(--color-primary-dark)',
    color:
      theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText,
  },
  chatBodyWrapper: { height: '100%', overflow: 'auto' },
  chatBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
    height: '90%',
    padding: '10px',
    boxSizing: 'border-box',
    overflowY: 'auto',
  },
  message: {
    borderRadius: '10px',
    padding: '10px',
    maxWidth: '65%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    wordBreak: 'break-word',
    '& img': {
      width: '100%',
      borderRadius: '10px',
    },
  },
  myMessage: {
    background:
      theme.palette.mode === Mode.Dark
        ? theme.palette.background.default
        : 'var(--color-primary) !important',
    alignSelf: 'flex-end',
    color:
      theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText,
  },
  incomingMessage: {
    background: 'rgba(217,217,217,0.35)',
    alignSelf: 'flex-start',
    color: theme.palette.text.primary,
    '& div:last-child': {
      color: theme.palette.text.primary,
    },
  },
  messageDate: {
    fontSize: 'small',
    color: theme.palette.text.secondary,
  },
  messageSender: {
    width: '100%',
    display: 'flex',
    fontWeight: 'bold',
  },
  sendIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '10px',
    cursor: 'pointer',
    gap: '10px',
    '& svg': {
      width: '20px',
      height: '20px',
      '& path': {
        fill: theme.palette.text.primary,
      },
    },
  },
  myMessageDate: {
    alignSelf: 'flex-end',
    color:
      theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText,
  },
  ticketIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    '& svg': {
      width: '20px',
      height: '20px',
      '& path': {
        fill: theme.palette.secondary.contrastText,
      },
    },
  },
  assignee: {
    display: 'flex',
    gap: '10px',
    padding: '10px 20px 0px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  ticketStatus: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    fontSize: 'small',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  date: { fontSize: 'small' },
  chatHeaderInfo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '15px 10px',
    boxSizing: 'border-box',
    gap: '15px',
    flexWrap: 'wrap',
  },
  divider: {
    height: '20px',
    width: '2px',
    background: 'lightgray',
  },
  chatHeader: {
    borderBottom: '1px solid lightgray',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '5px',
  },
  chatHeaderActions: {
    display: 'flex',
    alignItems: 'center',
  },
  ticketTitle: {
    padding: '0px 10px',
    boxSizing: 'border-box',
  },
  closedChat: {
    opacity: '0.5',
  },
  closedChatContainer: {
    border: '1px solid transparent',
    opacity: '0.8',
  },
  chatResolved: {
    padding: '10px 20px',
    margin: '0px auto',
    boxSizing: 'border-box',

    background:
      theme.palette.mode === Mode.Dark ? theme.palette.background.default : 'var(--color-primary)',
    color:
      theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText,
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& svg': {
      width: '20px',
      height: '20px',
      '& path': {
        fill: 'white',
      },
    },
  },
  attachment: {
    color: 'white !important',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& svg': {
      width: '30px',
      height: '30px',
      '& path': { stroke: 'white' },
    },
    '& a': {
      color: 'white !important',
    },
    '&:visited': {
      color: 'white',
    },
  },
  dropzoneOverload: {
    overflow: 'unset !important',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
    padding: '10px',
    boxSizing: 'border-box',
  },
  actionBar: {
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
  },
  badge: {
    width: '100%',
    '& div': {
      width: '100%',
    },
    '& span': {
      top: '15px',
    },
  },
  searchContainer: {
    padding: '10px 10px 0px 10px',
    boxSizing: 'border-box',
    '& input': {
      color: theme.palette.text.primary,
      '&::placeholder': {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    },
    '& svg path': {
      fill: theme.palette.text.primary,
    },
  },
  searchIcon: {
    width: '25px',
    height: '25px',
    cursor: 'pointer',
    '& path': {
      fill: 'rgba(0,0,0, 0.65)',
    },
  },
  progress: {
    width: '20px !important',
    height: '20px !important',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  chatBox: {
    padding: '35px 20px',
    background: theme.palette.background.paper,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    boxSizing: 'border-box',
    height: '95%',
    width: 'calc(100% - 40px)',
    borderRadius: '5px',
    margin: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  ticket: {
    '& path': {
      fill: theme.palette.text.primary,
    },
  },
  typingContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '17px',
    padding: '10px 20px',
    background: 'rgba(217,217,217,0.35)',
    border: ' 1px solid rgba(0, 64, 255, 0.19)',
    borderRadius: '10px',
    borderBottomLeftRadius: '2px',
    width: 'fit-content',
    color: theme.palette.text.primary,
    '& div:last-child': {
      color: theme.palette.text.primary,
    },
    opacity: 0,
    animation: '$fadeIn 0.3s ease-in forwards',
    '&.fadeOut': {
      animation: '$fadeOut 0.3s ease-out forwards',
    },
  },
  typingDot: {
    width: '7px',
    height: '7px',
    backgroundColor: '#6CAD96',
    borderRadius: '50%',
    marginRight: '4px',
    display: 'inline-block',
    animation: '$mercuryTypingAnimation 1.8s infinite ease-in-out',
    '&:nth-child(1)': {
      animationDelay: '200ms',
    },
    '&:nth-child(2)': {
      animationDelay: '300ms',
    },
    '&:nth-child(3)': {
      animationDelay: '400ms',
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  '@keyframes mercuryTypingAnimation': {
    '0%': {
      transform: 'translateY(0px)',
      backgroundColor: '#6CAD96',
    },
    '28%': {
      transform: 'translateY(-7px)',
      backgroundColor: '#9ECAB9',
    },
    '44%': {
      transform: 'translateY(0px)',
      backgroundColor: '#B5D9CB',
    },
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes fadeOut': {
    '0%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateY(10px)',
    },
  },
  chatNameText: {
    width: '70%',
  },
}));

export default useStyles;
